import Grid from '@mui/material/Unstable_Grid2';
import { DeloitteInfo, DeloitteSection, DeloitteServiceCard } from 'TaxAnalyticsUI/Deloitte';
import { Earth } from 'TaxAnalyticsImages';
import { useHistory } from 'react-router-dom';
import { Offers } from 'TaxAnalyticsComponents/mock';
import { Element, scroller } from 'react-scroll';
import { tag } from 'TaxAnalyticsHelpers/ATInternet';
import { useEffect } from 'react';

export function Home() {
    const history = useHistory();

    useEffect(() => {
        tag.sendPage({
            name: "Home"
        });
    }, [history.location.pathname]);


    return (
        <Grid container spacing={6}>
            <Grid container component="section" id="landing">
                <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
                    <Grid xs={12} sm={5} p={0}>
                        <DeloitteInfo title="TaxAnalytics" text="Accompagne les groupes dans la digitalisation des fonctions fiscales et finance et dans le suivi des contrôles fiscaux." buttonLabel="Découvrir" onClick={() => {
                            scroller.scrollTo('services', {
                                duration: 700,
                                delay: 50,
                                smooth: true,
                                offset: -147
                            })
                        }} />
                    </Grid>
                    <Grid xs={12} sm={7} p={0}>
                        <img src={Earth} style={{ maxWidth: '100%', opacity: '0.75' }} alt="CyberEarthLogo" />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container component="section" id="services">
                <Element name="services">
                    <DeloitteSection title="Nos services">
                        <Grid container spacing={4} alignItems="stretch" justifyContent="center" p={0}>
                            {Offers.sort(o => o.displayOrder).map((service, index) => {
                                if (service.tile)
                                    return (
                                        <Grid xs={12} md={4} key={index}>
                                            <DeloitteServiceCard {...service.tile} onClick={() => history.push(service.tile!.href)} cta />
                                        </Grid>
                                    )
                            }
                            )}
                        </Grid>
                    </DeloitteSection>
                </Element>
            </Grid>
        </Grid>
    );
}